// src/store/index.js
import { createStore } from 'vuex'
import auth from './modules/auth'
import tenant from './modules/tenant'
import userPrefs from './modules/userPrefs'
import entity from './modules/entity'
import featureConfig from './modules/featureConfig'
import rolePreview from './modules/rolePreview'
import supportItems from './modules/supportItems'
import demoMode from './modules/demoMode'
import exportsModule from './modules/exports'

export default createStore({
  modules: {
    auth,
    tenant,
    entity,
    userPrefs,
    featureConfig,
    rolePreview,
    supportItems,
    demoMode,
    exports: exportsModule,
  }
})
